import { useEffect } from "react";
import { RootState } from "../../../store";
import { connect } from "react-redux";
import {
  selectIsPaid,
  selectIsTestPeriod, selectSubscriptionLevel,
  selectUserData,
} from "../../../store/selectors";
import { Error } from "../../common/Error";
import { ReactComponent as LockIcon } from "../../../assets/icons/lock.svg";
import { useNavigate } from "react-router-dom";
import {SUBSCRIPTION_PLANS} from "../../../constants/common";
import {
  ANALYTICS_EVENTS,
  trackAnalyticsEvent,
} from "../../../analytics";

export const _PaidHoc = ({
  children,
  paid,
  testPeriod,
  renderCustom,
  customTitle,
  customDescription,
  customButtonText,
    customAction,
                           subscriptionLevel,
                           analyticsFeature = "paid_feature",
}) => {
  const navigate = useNavigate();
  const hasAccess = subscriptionLevel === SUBSCRIPTION_PLANS.personal.name;

  useEffect(() => {
    if (!hasAccess) {
      trackAnalyticsEvent(ANALYTICS_EVENTS.FEATURE_ACCESS_DENIED, {
        feature_key: analyticsFeature,
        required_subscription: SUBSCRIPTION_PLANS.personal.name,
        current_subscription: subscriptionLevel || "unknown",
      });
    }
  }, [analyticsFeature, hasAccess, subscriptionLevel]);

  const handleClick = () => {
    trackAnalyticsEvent(ANALYTICS_EVENTS.PAYMENT_OPENED, {
      payment_source: "feature_access_denied",
      feature_key: analyticsFeature,
    });
    if (customAction) {
      customAction();
    }
    navigate("/payment/");
  }

  if (hasAccess) {
    return children;
  }

  return (
    <>
      {renderCustom && renderCustom}
      <Error
        title={customTitle || "Нет доступа к разделу"}
        description={customDescription || "Для получения доступа необходимо оформить подписку"}
        buttonText={customButtonText || "выбрать тариф"}
        retryCallback={handleClick}
        icon={<LockIcon />}
      />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  paid: selectIsPaid(state),
  userData: selectUserData(state),
  testPeriod: selectIsTestPeriod(state),
  subscriptionLevel: selectSubscriptionLevel(state),
});

const mapDispatchToProps = {};

export const PaidHoc = connect(mapStateToProps, mapDispatchToProps)(_PaidHoc);
